<template>
    <b-row class="vh-100" align-v="center">
        <b-col cols="12" md="8" offset-md="2" align-self="center">
            <b-row align-h="center">
                <b-col cols="12" class="text-center mb-4">
                    <div class="icon-wrapper mb-3">
                        <b-icon icon="credit-card" font-scale="3" variant="primary"></b-icon>
                    </div>
                    <h2 class="onboarding-title">{{ $t('monri.title') }}</h2>
                </b-col>

                <b-col cols="12" class="mb-4">
                    <div class="promo-offer">
                        <div class="offer-badge mb-3">
                            <b-badge variant="success" pill class="px-3 py-2">
                                <b-icon icon="gift" class="mr-1"></b-icon>
                                {{ $t('monri.specialOffer') }}
                            </b-badge>
                        </div>
                        
                        <div class="offer-content">
                            <h4 class="offer-title">{{ $t('monri.offerTitle') }}</h4>
                            <p class="offer-description">
                                {{ $t('monri.offerDescription') }}
                            </p>
                            
                            <div class="offer-features mt-4">
                                <div class="feature-item" v-for="(feature, index) in features" :key="index">
                                    <b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon>
                                    <span>{{ feature }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" class="mt-3">
                    <b-button variant="success" size="lg" @click="success" block class="agree-button">
                        <b-icon icon="check-circle" class="mr-2"></b-icon>
                        {{ $t('monri.agree') }}
                    </b-button>
                    <p class="text-muted text-center mt-3 small">
                        {{ $t('monri.agreeNote') }}
                    </p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import OnboardingLayout from '@/components/integrations/OnboardingLayout.vue'

export default {
    components: {
        OnboardingLayout
    },

    data: function() {
        return {}
    },

    i18n: {
        messages: {
            en_US: {
                monri: {
                    title: 'Welcome to Monri Payment Integration',
                    specialOffer: 'Special Offer',
                    offerTitle: 'Exclusive Protokol Partnership Benefits',
                    offerDescription: 'As a Protokol user, you get access to special terms and priority support from Monri payment platform.',
                    feature1: 'Reduced transaction fees for Protokol users',
                    feature2: 'Fast-track onboarding and priority support',
                    feature3: 'Advanced fraud protection included',
                    feature4: 'Real-time payment analytics and reporting',
                    agree: 'I Agree - Continue Setup',
                    agreeNote: 'By continuing, you agree to proceed with Monri integration setup'
                }
            },

            sr: {
                monri: {
                    title: 'Dobrodošli u Monri Integraciju Plaćanja',
                    specialOffer: 'Specijalna Ponuda',
                    offerTitle: 'Ekskluzivne Pogodnosti Protokol Partnerstva',
                    offerDescription: 'Kao Protokol korisnik, dobijate pristup specijalnim uslovima i prioritetnoj podršci od Monri platne platforme.',
                    feature1: 'Smanjene transakcione naknade za Protokol korisnike',
                    feature2: 'Ubrzani onboarding i prioritetna podrška',
                    feature3: 'Napredna zaštita od prevara uključena',
                    feature4: 'Analitika i izveštaji o plaćanjima u realnom vremenu',
                    agree: 'Slažem se - Nastavi sa Podešavanjem',
                    agreeNote: 'Nastavljajući, slažete se da nastavite sa podešavanjem Monri integracije'
                }
            }
        }
    },

    computed: {
        features() {
            return [
                this.$t('monri.feature1'),
                this.$t('monri.feature2'),
                this.$t('monri.feature3'),
                this.$t('monri.feature4')
            ]
        }
    },

    methods: {
        async success() {
            try {
                const data = await this.$store.dispatch('updateIntegrationOnboarding', {
                    integrationId: 'monri',
                    step: "show-promo-offer",
                    data: {
                        promo_accepted: true
                    }
                })

                console.log("Monri onboarding updated:", data)

                if (data.onboarding.status == 'completed') {
                    this.$emit('onboardingSuccess', 'integration', 'monri')
                }
            } catch(err) {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            }
        }
    },

    mounted() {}
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/style.scss';
@import '@/assets/scss/_custom.scss';

.icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));
    border-radius: 50%;
    border: 2px solid rgba(102, 126, 234, 0.3);
}

.onboarding-title {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
}

.promo-offer {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.05));
    border: 1px solid rgba(102, 126, 234, 0.3);
    border-radius: 12px;
    padding: 1.5rem;
}

.offer-badge {
    text-align: center;
    
    .badge {
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
}

.offer-title {
    font-size: 1.3rem;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 0.75rem;
    text-align: center;
}

.offer-description {
    color: var(--text-secondary);
    font-size: 1rem;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 0;
}

.offer-features {
    .feature-item {
        display: flex;
        align-items: center;
        padding: 0.75rem;
        background: rgba(16, 185, 129, 0.05);
        border-left: 3px solid rgba(16, 185, 129, 0.5);
        border-radius: 4px;
        margin-bottom: 0.75rem;
        
        span {
            color: var(--text-primary);
            font-size: 0.95rem;
        }
        
        &:last-child {
            margin-bottom: 0;
        }
    }
}

.agree-button {
    font-size: 1.1rem;
    font-weight: 600;
    padding: 0.75rem 2rem;
    transition: all 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
    }
}

.text-muted {
    color: var(--text-muted) !important;
}
</style>